import React from "react";
import { InfiniteScrollList } from "../../../components/table";
import { getDocHeadersList } from "../../api/docListsandDetails";
import * as routes from "../../../app/routes";
import * as modules from "../../../utils/modules";
import { moduleType } from "../../../utils/modules";

function InternalMovementsList() {
  const params = React.useMemo<{
    module: moduleType;
    cellType: "header" | "info" | "item";
    link: string;
    linkId?: "operationCode";
  }>(
    () => ({
      module: modules.MODULE_INTERNAL,
      cellType: "header",
      link: routes.ROUTE_INTERNAL_DETAILS.path,
      linkId: "operationCode",
    }),
    []
  );

  return (
    <InfiniteScrollList
      loadData={getDocHeadersList}
      loadDataparams={params}
      externalFilter
    />
  );
}

export default InternalMovementsList;
